import { ONBOARDING_STEP } from '@schema/initiative'
import { PhaseType } from '@schema/phase'

export const initiativeCreationSteps = {
  phaseSelection: 'phaseSelection',
  ...ONBOARDING_STEP,
} as const
export type InitiativeCreationStep = keyof typeof initiativeCreationSteps

const {
  phaseSelection,
  mainDetails,
  pageContent,
  livingParameters,
  membersParameters,
  legalInfo,
  amenities,
  contactDetails,
  callSchedule,
  finish,
} = initiativeCreationSteps

export const creationWorkflow: Record<PhaseType, InitiativeCreationStep[]> = {
  idea: [
    phaseSelection,
    mainDetails,
    pageContent,
    livingParameters,
    membersParameters,
    contactDetails,
    callSchedule,
    finish,
  ],
  location: [
    phaseSelection,
    mainDetails,
    pageContent,
    livingParameters,
    membersParameters,
    legalInfo,
    contactDetails,
    callSchedule,
    finish,
  ],
  design: [
    phaseSelection,
    mainDetails,
    pageContent,
    livingParameters,
    membersParameters,
    legalInfo,
    contactDetails,
    callSchedule,
    finish,
  ],
  construction: [
    phaseSelection,
    mainDetails,
    pageContent,
    livingParameters,
    membersParameters,
    legalInfo,
    contactDetails,
    callSchedule,
    finish,
  ],
  living: [
    phaseSelection,
    mainDetails,
    pageContent,
    livingParameters,
    membersParameters,
    amenities,
    contactDetails,
    callSchedule,
    finish,
  ],
}

export const creationGuideDisplay = (
  phase: PhaseType | null,
  currentStep: InitiativeCreationStep,
): InitiativeCreationStep[] => {
  const steps = phase ? listedSteps(creationWorkflow[phase]) : []
  const guideDisplay = {
    phaseSelection: [phaseSelection],
    mainDetails: steps,
    pageContent: steps,
    livingParameters: steps,
    membersParameters: steps,
    legalInfo: steps,
    amenities: steps,
    contactDetails: steps,
    callSchedule: [callSchedule],
    finish: [finish],
  }

  return guideDisplay[currentStep]
}

export const unlistedSteps: InitiativeCreationStep[] = [
  phaseSelection,
  callSchedule,
  finish,
] as const

export const listedSteps = (
  steps: InitiativeCreationStep[],
): InitiativeCreationStep[] =>
  steps.filter((step) => !unlistedSteps.includes(step))

/** Single source of truth: whether an onboarding step exists for this phase (e.g. about-page sections). */
export const phaseWorkflowIncludes = (
  phaseType: PhaseType,
  step: InitiativeCreationStep,
): boolean => creationWorkflow[phaseType].includes(step)
